// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActualSavings_wrapper__hOO90","table":"ActualSavings_table__s6Su1"};